package com.yogaaicoach.pages.trainingprogram

// Mirrors composeApp's LevelKey enum (pages/trainingprogram/data/models/LevelKey.kt) — already a
// plain enum there, no stripping needed.
enum class LevelKey {
    ABSOLUTE_BEGINNER,
    ADVANCED_BEGINNER,
    INTERMEDIATE,
    ADVANCED_INTERMEDIATE,
    ADVANCED,
}
